export default __webpack_public_path__ + "i18n/translations/translation-es.ca77d68d.json";